import { RoutePath } from "#src/utils/route";
import { WorkerRoutePath } from "../..";

/** Create-worker-version route under a specific worker. Path includes :workerId so CreateWorkerVersionPage and toLink({ pathParams: { workerId } }) work. */
export const WorkerVersionsCreateRoutePath = WorkerRoutePath.concat(
  new RoutePath({
    path: "/versions",
    title: "Worker Versions",
    isPresentational: true,
  })
).concat(
  new RoutePath({
    path: "/create",
    title: "Create Worker Version",
  })
);
